<template>
  <div>
    <list-table
      :fields="fields"
      :url="url"
      :excelroute="true"
      :params="params"
    ></list-table>
  </div>
</template>
<style >
.ltr-dir{
  direction: ltr;
}
</style>
<script>
import TableShowData from "@/components/table";
import { GET_USER_LIST } from "@/core/services/store/getUserList.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import _ from "lodash";
import * as moment from "jalali-moment";
import { format } from "path";

export default {
  name: "AccountersReportRefunds",

  data() {
    return {
      url: "~reports/api/admin-refunds",

      fields: [
        {
          key: "id",
          label: "کد درخواست",
        },
        {
          key: "transaction_id",
          label: "کد تراکنش برگشت شده",
        },
        {
          key: "created_at",
          label: "تاریخ و ساعت",
          formatter(value, key, item) {
            return moment(value, "YYYY/MM/DDThh:mm:ss").format(
              "jYYYY/jMM/jDD hh:mm:ss"
            ); //persianDate.getDate(value) +" , " +persianDate.getTime(value);
          },
          tdClass() {
            return "ltr-dir";
          },
        },
        {
          key: "website_name",
          label: "وب سایت",
        },
        {
          key: "card_holder_pan",
          label: "شماره کارت مقصد",
          tdClass: "ltr",
        },
        {
          key: "sale_refrence_id",
          label: "کد رهگیری تراکنش اصلی",
        },
        {
          key: "tracking_number",
          label: "کد رهگیری تراکنش برگشت",
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            return value ? value.toLocaleString() : 0;
          },
          tdClass() {
            return "ltr-dir";
          },
        },
        {
          key: "wage",
          label: "کارمزد (ریال)",
          formatter(value, key, item) {
            return value ? value.toLocaleString() : 0;
          },
          tdClass() {
            return "ltr-dir text-danger";
          }
        },
        // {
        //   key: "totalsum",
        //   label: "مانده (ریال)",
        //   formatter(value, key, item) {
        //     return value ? value.toLocaleString(): 0;
        //   },
        //   tdClass:"text-success"
        // },
        {
          key: "description",
          label: "توضیحات",
          formatter(value, key, item) {
            return item.amount > 0 ? "شارژ اکانت" : "برگشت وجه";
          },
          tdClass(value, key, item) {
            return item.amount > 0 ? "text-success" : "text-danger";
          },
        },
      ],

      params: [
        {
          label: "از تاریخ:",
          field: "date_from",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "date_to",
          type: "date-picker",
        },
        {
          label: "پذیرنده",
          field: "user_id",
          type: "select",
          value: null,
          options: [],
        },
        {
          label: "کد رهگیری برگشت:",
          field: "tracking_number",
          type: "text",
        },
        {
          label: "مبلغ (ریال) :",
          field: "amount",
          type: "number",
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  computed: {
    loadedUserList() {
      return this.$store.getters.loadedUserList;
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "گزارشات مالی",
        route: "merchants",
      },
      {
        title: "ریفاند ها",
      },
    ]);
    this.getUserList();
  },
  methods: {
    getUserList() {
      this.$store.dispatch(GET_USER_LIST, "users-with-refund").then((data) => {
        let option = [{ text: "انتخاب نشده", value: null }];
        data.forEach((element) => {
          option.push({ text: element.name, value: element.id });
        });

        this.params[2].options = option;
      });
    },
  },
};
</script>
<style >
.ltr {
  direction: ltr;
}
</style>